// Texto de "detail" mostrado tanto no toast (RouterboardTemplate, ações do rodapé) quanto no
// resultado inline de cada etapa da aba Provisionar (RouterboardProvisionarPanel) - single
// source of truth pra nunca divergirem (card Trello #103, pedido do usuário: o resultado do
// stepper deve mostrar exatamente o mesmo texto que já aparecia no toast de cada ação).
const RouterboardResultados = {
    testarConexao(res) {
        return res?.status
            ? 'Equipamento Conectado - Versão - ' + res?.data?.retorno?.version
            : [res?.data?.mensagem, res?.data?.detalhes].filter(Boolean).join(' — ');
    },
    testarSsh(res) {
        return res?.status
            ? res?.data?.retorno
            : [res?.data?.mensagem, res?.data?.detalhes].filter(Boolean).join(' — ');
    },
    ativarApi(res, descricaoEquipamento) {
        return res?.status
            ? `API REST ativada com sucesso no equipamento ${descricaoEquipamento}.`
            : res?.data?.mensagem;
    },
    // Sucesso aqui só é reportado depois de o backend confirmar no equipamento qual certificado
    // ficou vinculado ao www-ssl (card Trello #105) - mostrar o nome desse certificado é a
    // evidência de que a emissão realmente aconteceu, e não só de que o comando não deu erro.
    ativarSslLetsEncrypt(res, descricaoEquipamento) {
        return res?.status
            ? `Certificado SSL ativado com sucesso no equipamento ${descricaoEquipamento}.`
                + (res?.data?.certificado ? ` Certificado "${res.data.certificado}" vinculado ao serviço www-ssl.` : '')
            : [res?.data?.mensagem, res?.data?.detalhes].filter(Boolean).join(' — ');
    },
    gerarScript(res, descricaoEquipamento) {
        return res?.status
            ? `Script gerado com sucesso para o equipamento ${descricaoEquipamento}.`
            : res?.data?.mensagem;
    },
    executarScript(res, descricaoEquipamento) {
        return res?.status
            ? `Script executado com sucesso no equipamento ${descricaoEquipamento}.`
            : res?.data?.mensagem;
    },
};

export default RouterboardResultados;
